import {Component, OnInit} from '@angular/core';
import {AlertService, JhiLanguageService} from 'ng-jhipster';
import {ParametrageService} from '../parametrage';
import {Response} from '@angular/http';
import {Contact} from './contact.model';
import {CALENDAR_FR} from '../../shared/calendar/calendar.constants';
import {ContactService} from './contact.service';


@Component({
    selector: 'jhi-contact',
    templateUrl: './contact.component.html'
})
export class ContactComponent implements OnInit {
    contact: Contact;
    parametrage: any;
    fr: any;
    currentLang: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private parametrageService: ParametrageService,
        private contactService: ContactService,
        private alertService: AlertService
    ) {
        this.jhiLanguageService.setLocations(['contact']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }

    ngOnInit() {
        this.fr = CALENDAR_FR;
        this.contact = {};
        this.parametrageService.queryPageAll().subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
    }

    sendEmail() {
        this.contactService.create(this.contact).subscribe(
            (res: Response) => this.onSuccess(res),
            (res: Response) => this.onError(res));
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }

    private onSuccess (data) {
        this.alertService.success('cadensApp.contact.sent', null, null);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact/contact.component.ts